/**
 * dnd-kit modifier that confines a dragged item's transform to the bounds of
 * its parent element. Prevents the drag preview from drifting outside the list
 * container (e.g. floating past the pagination control below the list).
 *
 * This is the standard implementation from `@dnd-kit/modifiers`, inlined to
 * avoid adding the dependency for a single modifier.
 *
 * @param {object} args - dnd-kit modifier args
 * @param {DOMRect} args.containerNodeRect - bounding rect of the draggable's parent
 * @param {DOMRect} args.draggingNodeRect - bounding rect of the dragged node
 * @param {{x: number, y: number, scaleX: number, scaleY: number}} args.transform
 * @returns {object} the clamped transform
 */
export const restrictToParentElement = ({ containerNodeRect, draggingNodeRect, transform }) => {
  if (!draggingNodeRect || !containerNodeRect) {
    return transform
  }

  const restrictedTransform = { ...transform }

  if (draggingNodeRect.top + transform.y <= containerNodeRect.top) {
    restrictedTransform.y = containerNodeRect.top - draggingNodeRect.top
  } else if (draggingNodeRect.bottom + transform.y >= containerNodeRect.top + containerNodeRect.height) {
    restrictedTransform.y = containerNodeRect.top + containerNodeRect.height - draggingNodeRect.bottom
  }

  if (draggingNodeRect.left + transform.x <= containerNodeRect.left) {
    restrictedTransform.x = containerNodeRect.left - draggingNodeRect.left
  } else if (draggingNodeRect.right + transform.x >= containerNodeRect.left + containerNodeRect.width) {
    restrictedTransform.x = containerNodeRect.left + containerNodeRect.width - draggingNodeRect.right
  }

  return restrictedTransform
}
